var $92d9ad162d1f4bfd$exports = {};
function $92d9ad162d1f4bfd$var$formatDate(date) {
    let hours = date.getHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = date.getMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let dayIndex = date.getDay();
    let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    let day = days[dayIndex];
    return `${day} ${hours}:${minutes}`;
}
/*function locationTime(cityTime) {
  let zone = new Date();

  if (cityTime != undefined) {
    let milliseconds = cityTime * 1000;
    let localMilliseconds = zone.getTimezoneOffset() * 60000;
    zone = new Date(now.getTime() + milliseconds + localMilliseconds);
  }
}*/ function $92d9ad162d1f4bfd$var$displayWeather(response) {
    document.querySelector("#search-city").innerHTML = response.data.name;
    document.querySelector("#temperature").innerHTML = Math.round(response.data.main.temp);
    document.querySelector("#humidity").innerHTML = response.data.main.humidity;
    document.querySelector("#wind").innerHTML = Math.round(response.data.wind.speed);
    document.querySelector("#climate").innerHTML = response.data.weather[0].main;
}
function $92d9ad162d1f4bfd$var$searchCity(city) {
    let apiKey = "cabdbda40038ba7d1165b953b1c7bd6c";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then($92d9ad162d1f4bfd$var$displayWeather);
}
function $92d9ad162d1f4bfd$var$handleSubmit(event) {
    event.preventDefault();
    let city = document.querySelector("#search-city").value;
    $92d9ad162d1f4bfd$var$searchCity(city);
}
function $92d9ad162d1f4bfd$var$searchLocation(position) {
    let apiKey = "cabdbda40038ba7d1165b953b1c7bd6c";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then($92d9ad162d1f4bfd$var$displayWeather);
}
function $92d9ad162d1f4bfd$var$getCurrentLocation(event) {
    event.preventDefault();
    navigator.geolocation.getCurrentPosition($92d9ad162d1f4bfd$var$searchLocation);
}
function $92d9ad162d1f4bfd$var$convertFahrenheit(event) {
    event.preventDefault();
    let temperatureElement = document.querySelector("#temperature");
    temperatureElement.innerHTML = 66;
}
function $92d9ad162d1f4bfd$var$convertCelsius(event) {
    event.preventDefault();
    let temperatureElement = document.querySelector("#temperature");
    temperatureElement.innerHTML = 19;
}
let $92d9ad162d1f4bfd$var$dateElement = document.querySelector("#date");
let $92d9ad162d1f4bfd$var$currentTime = new Date();
$92d9ad162d1f4bfd$var$dateElement.innerHTML = $92d9ad162d1f4bfd$var$formatDate($92d9ad162d1f4bfd$var$currentTime);
let $92d9ad162d1f4bfd$var$searchForm = document.querySelector("#search-form");
$92d9ad162d1f4bfd$var$searchForm.addEventListener("submit", $92d9ad162d1f4bfd$var$handleSubmit);
let $92d9ad162d1f4bfd$var$currentLocationButton = document.querySelector("#current-location-button");
$92d9ad162d1f4bfd$var$currentLocationButton.addEventListener("click", $92d9ad162d1f4bfd$var$getCurrentLocation);
$92d9ad162d1f4bfd$var$searchCity("New York");


//# sourceMappingURL=index.75869851.js.map
